import React from 'react';
import { BiLoggerContextProvider } from '../../../biLogger';
import { GallectionResourceType } from '../../../types/gallection';
import MoreByAuthor from '../../_partials/MoreByAuthor';
import SimpleDeviationGridBlock from '../../_partials/SimpleDeviationGridBlock';
export var Gallery = function (_a) {
    var gallery = _a.gallery, parentDeviation = _a.parentDeviation;
    return (React.createElement(BiLoggerContextProvider, { value: {
            sectionname: 'gallery',
            section_typeid: GallectionResourceType.GALLERY,
        } },
        React.createElement(SimpleDeviationGridBlock, { streamKey: "gallery", deviations: gallery, parentDeviation: parentDeviation, titleOverride: parentDeviation.author && (React.createElement(MoreByAuthor, { author: parentDeviation.author, i18nSubKey: "gallery", linkToProfileSection: "gallery" })) })));
};
Gallery.displayName = 'Gallery';
export default Gallery;
//# sourceMappingURL=Gallery.js.map